import { createContext } from "react";

const QuickAssignmentContext = createContext();

export default QuickAssignmentContext;